import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { noop } from "lodash";
import css from "@styled-system/css";
import { Box, Modal } from "@mm/ui";

export const OpenerButton = styled.button`
  background: 0;
  border: 0;
  cursor: pointer;
  display: inline;
  line-height: 1.5;
  padding: 0;
  height: inherit;

  span {
    font-size: 0.8rem;
    margin-right: 0.25rem;
    text-decoration: underline;

    &.tariffDetail {
      color: #3a3a3a;
    }

    &.energy {
      font-size: 14px;
      color: #3a3a3a;
    }

    &.internet {
      margin: 0 0.25rem;
    }
  }

  i {
    font-size: 1rem;
    margin-left: 0.25rem;
    text-decoration: none;
  }
`;

class GeneralModalShell extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalIsOpen: props.isOpen || false,
      isControlled: props.isOpen !== undefined,
    };

    this.toggleModal = this.toggleModal.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (
      nextProps.isOpen !== undefined &&
      nextProps.isOpen !== prevState.modalIsOpen
    ) {
      return {
        modalIsOpen: nextProps.isOpen,
      };
    }
    return null;
  }

  handleKeyDown(ev) {
    ev.preventDefault();
    if (ev.keyCode === 13) {
      this.toggleModal(ev);
    }
  }

  toggleModal(e) {
    e.preventDefault();
    const { trackingObj = false } = this.props;
    const { modalIsOpen, isControlled } = this.state;
    if (!modalIsOpen && trackingObj && window.dataLayer) {
      window.dataLayer.push(trackingObj);
    }

    if (isControlled) {
      this.props.onToggle(!modalIsOpen);
    } else {
      this.setState({ modalIsOpen: !modalIsOpen });
    }
  }

  render() {
    const {
      children,
      opener,
      afterOpen = undefined,
      size,
      dynamicHeight,
      closable,
      maxHeightOffSet,
      ariaLabel,
    } = this.props;
    const { modalIsOpen } = this.state;

    return (
      <Box
        {...this.props}
        height={dynamicHeight ? "100%" : "auto"}
        css={css({
          display: "inline-block",
        })}
      >
        <OpenerButton
          type="button"
          aria-haspopup="dialog"
          aria-label={ariaLabel}
          onClick={(e) => {
            e.stopPropagation();
            this.toggleModal(e);
          }}
        >
          {opener}
        </OpenerButton>
        {modalIsOpen && (
          <Modal
            dynamicHeight={dynamicHeight}
            isInitialOpen={modalIsOpen}
            onAfterOpen={afterOpen}
            onRequestClose={(e) => {
              if (closable) {
                this.toggleModal(e);
                e.stopPropagation();
              }
            }}
            closable={closable}
            size={size}
            maxHeightOffSet={maxHeightOffSet}
          >
            {children}
          </Modal>
        )}
      </Box>
    );
  }
}

GeneralModalShell.propTypes = {
  afterOpen: PropTypes.func,
  children: PropTypes.node.isRequired,
  opener: PropTypes.node,
  trackingObj: PropTypes.any,
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
  size: PropTypes.oneOf(["sm", "md", "lg", "xl", "xxl"]),
  dynamicHeight: PropTypes.bool,
  closable: PropTypes.bool,
  maxHeightOffSet: PropTypes.shape({}),
};

GeneralModalShell.defaultProps = {
  opener: null,
  afterOpen: noop,
  isOpen: undefined,
  onToggle: noop,
  trackingObj: {},
  size: "lg",
  dynamicHeight: false,
  closable: true,
  maxHeightOffSet: {
    md: "64px",
    lg: "128px",
  },
};

export default GeneralModalShell;
